module.exports = __webpack_public_path__ + "img/celebrate-2.8dda9860.jpg";